export const showShinkaIndicator = (
	shinkaConfigured: boolean,
	shinkaAmount?: number,
	totalIncludingTax?: number
): boolean => shinkaConfigured && (totalIncludingTax && shinkaAmount ? totalIncludingTax >= shinkaAmount * 0.5 : false);
